var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 9.33333V8.57143C7.5 6.039 9.50714 4 12 4C14.4929 4 16.5 6.039 16.5 8.57143V9.33333M7.5 9.33333C6.675 9.33333 6 10.019 6 10.8571V18.4762C6 19.3143 6.675 20 7.5 20H16.5C17.325 20 18 19.3143 18 18.4762V10.8571C18 10.019 17.325 9.33333 16.5 9.33333M7.5 9.33333H16.5",
    stroke: "#434343",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.6bb08136ed66a26e5d38de8f3c64a644.svg";
export { ForwardRef as ReactComponent };